import { render, staticRenderFns } from "./SearchResultsUtilityBanner.vue?vue&type=template&id=132bc2ba"
import script from "./SearchResultsUtilityBanner.vue?vue&type=script&lang=js"
export * from "./SearchResultsUtilityBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports